import { render } from "./PaymentSet.vue?vue&type=template&id=ed976b9a&scoped=true"
import script from "./PaymentSet.vue?vue&type=script&lang=js"
export * from "./PaymentSet.vue?vue&type=script&lang=js"

import "./PaymentSet.vue?vue&type=style&index=0&id=ed976b9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed976b9a"]])

export default __exports__